export class Provincia {
	id!: number;
	rid!: number;
	regione?: string;
	descrizione?: string;
	sigla?: string;
}
